// helpers
import DTM from 'shared/helpers/DTM';

export const onSelectedTabRender = (tabName: string) => {
  DTM.updateDatalayer({ selectedBottomNavState: tabName });
};

export const onTabClick = ({ storeName, tabName }: { storeName: string; tabName: string }) => {
  DTM.track('bottom-nav-tab-click', { storeName, tabName });
};
